import { isMaskedNode } from '@creative/nodes/helpers';
import { cloneDeep } from '@studio/utils/clone';
export class MaskingRenderMap {
    constructor() {
        /** Map<"Mask element id", MaskingRenderMapValue> */
        this._renderMap = new Map();
    }
    set_m(element, changedOnPreviousPass) {
        var _a;
        const key = this._getKey(element);
        const mappedMask = (_a = this._renderMap.get(key)) !== null && _a !== void 0 ? _a : {
            elements: new Set(),
            changedOnPreviousPass
        };
        this._renderMap.set(key, {
            elements: mappedMask.elements.add(key),
            changedOnPreviousPass
        });
        return mappedMask;
    }
    get_m(element) {
        const key = this._getKey(element);
        const value = this._renderMap.get(key);
        return cloneDeep(value);
    }
    delete_m(element) {
        var _a;
        const key = this._getKey(element);
        this._renderMap.delete(key);
        (_a = this._renderMap.get(key)) === null || _a === void 0 ? void 0 : _a.elements.delete(key);
    }
    _getKey(element) {
        var _a;
        return isMaskedNode(element) ? ((_a = element.masking.elementId) !== null && _a !== void 0 ? _a : '') : element.id;
    }
    clear_m() {
        this._renderMap.clear();
    }
}
